module.exports = __WEBPACK_EXTERNAL_MODULE_168__;


//////////////////
// WEBPACK FOOTER
// external {"root":"React","commonjs2":"react","commonjs":"react","amd":"react"}
// module id = 168
// module chunks = 0